import api from "@/api/viktor"

export type InvitationRole = "candidate" | "admin" | "recruiter" | "manager"

type InvitationsResponse = {
  body?: unknown[]
}

// Auth invitation routes (relative to auth_url)
const SHARE_PROFILE_ROUTE = "/invitations/share-profile"
const ROLE_ROUTE = "/invitations/role"

/**
 * Fetch the current user's invitations for a given role.
 */
export async function getMeInvitations(
  role: InvitationRole
): Promise<InvitationsResponse> {
  let url = `/me/invitations?role=${role}`
  if (role === "candidate") url += "&fields=created_at,sharepool_user.uuid"

  return api({
    method: "get",
    url,
  })
}

function hasInvites(res: InvitationsResponse): boolean {
  return Array.isArray(res?.body) && res.body.length > 0
}

/**
 * Resolve the auth invitation route the user should be redirected to,
 * or null when there is no pending invitation.
 * - admin / recruiter / manager invites -> /invitations/role (checked first)
 * - candidate invites                    -> /invitations/share-profile
 */
export async function getPendingInvitationRedirect(): Promise<string | null> {
  const [adminInvites, recruiterInvites, managerInvites, candidateInvites] =
    await Promise.all([
      getMeInvitations("admin"),
      getMeInvitations("recruiter"),
      getMeInvitations("manager"),
      getMeInvitations("candidate"),
    ])

  if (
    hasInvites(adminInvites) ||
    hasInvites(recruiterInvites) ||
    hasInvites(managerInvites)
  ) {
    return ROLE_ROUTE
  }

  if (hasInvites(candidateInvites)) {
    return SHARE_PROFILE_ROUTE
  }

  return null
}
